module.exports = __webpack_public_path__ + "img/logo__irwin_homes--light.dd7c7c65.webp";